module.exports = __webpack_public_path__ + "static/img/home_zjgx_pic3.edb9580.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_zjgx_pic3.png
// module id = hhuf
// module chunks = 0